export const NewAccreditationProcess = 'NewAccreditationProcess';
export const NewAccreditationProcessStepObservation = 'NewAccreditationProcessStepObservation';
export const AccreditationProcessWasAdminApproved = 'AccreditationProcessWasAdminApproved';
export const NewAccreditationProcessObservation = 'NewAccreditationProcessObservation';
export const AccreditationProcessStepIsAlmostExpired = 'AccreditationProcessStepIsAlmostExpired';
export const AccreditationProcessStepHasExpired = 'AccreditationProcessStepHasExpired';